module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<!--确认订单信息-->\n<div class="confirm-order-msg">\n  <h5 class="palce-can-move">确认订单信息</h5>\n  <div class="final-order-msg">\n    <ul>\n      <li>\n        <span>预定门票</span>\n        <p>' +
((__t = ( data.itemName )) == null ? '' : __t) +
' --- ' +
((__t = ( data.ticketTypeName)) == null ? '' : __t) +
'</p>\n      </li>\n      <li>\n        <span>门票日期</span>\n        <p>' +
((__t = ( data.checkInDate )) == null ? '' : __t) +
' ' +
((__t = ( data.screeningName )) == null ? '' : __t) +
'</p>\n      </li>\n      <li>\n        <span>预定票数</span>\n        <p>' +
((__t = ( data.acount )) == null ? '' : __t) +
'</p>\n      </li>\n      <li class="t-o-c-player">\n\n      </li>\n      <li>\n        <span>支付方式</span>\n        <p class="ticketBalanceWay">' +
((__t = ( data.salePrice )) == null ? '' : __t) +
'</p>\n      </li>\n      <li>\n        <span>取消条款</span>\n        <p class="ticketCancelContent">' +
((__t = ( data.salePrice )) == null ? '' : __t) +
'</p>\n      </li>\n      <li>\n        <span>订单价格</span>\n        <p>' +
((__t = ( data.salePrice )) == null ? '' : __t) +
'</p>\n      </li>\n    </ul>\n  </div>\n  <div class="confirm-msg-bot">\n    <button class="confirm-order">确认</button>\n    <button class="cancel-order">取消</button>\n  </div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/js/ticketOrderConfirm/templates/confirmOrderMsg.ejs
// module id = 77
// module chunks = 0 1 2 6 10 14